import { Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges } from '@angular/core';
import { DatePipe } from '@angular/common';
import { TInterValoHoraPuntoInspeccionViewModel } from '../../../../_mantenimiento/general/puntosinspeccion/puntoinspeccion.types';
import { GlobalService } from '../../../../core/_infrastructure/classes/services/global.service';
import { PuntoInspeccionService } from '../../../../_mantenimiento/general/puntosinspeccion/puntoinspeccion.service';
import { ComponentBase } from '../../../../core/_infrastructure/classes/componentBase';
import { EnumIdsTcPais, Tc } from '../../../../core/_infrastructure/types/common';
import { FormGroup, Validators } from '@angular/forms';
import { AuthService } from '../../../../core/_infrastructure/classes/services/auth.service';
import { NotificationService } from '../../../../core/_infrastructure/classes/services/notification.service';
import { ExceptionManager } from '../../../../core/_infrastructure/classes/handlers/exceptionManager';

@Component({
    selector: 'app-reasignacionpcf-edit',
    templateUrl: './reasignacionpcf-edit.component.html',
})
export class ReasignacionPcfEditComponent extends ComponentBase implements OnInit {
    @Input() formGroup: FormGroup;
    @Input() listPuntoInspeccion: Tc[] = [];
    @Input() listHoras: TInterValoHoraPuntoInspeccionViewModel[] = [];
    @Input() listUbicacion: Tc[] = [];
    @Input() listInstalacionAutorizada: Tc[] = [];
    @Output() onChangePuntoInspeccion = new EventEmitter<number | null>();

    HoraReasignacion: string | null = null;
    IdProvincia: number | null = null;
    campoUbicacion = true;
    campoInstalacion = true;
    validacionCollection: string[] = [];

    constructor(
        public datepipe: DatePipe,
        protected authService: AuthService,
        protected notificacionService: NotificationService,
        protected exceptionHandler: ExceptionManager,
    ) {
        super(authService, notificacionService, exceptionHandler);
    }

    ngOnInit() {
        this.form = this.formGroup;
    }

    onSelectPuntoInspeccion() {
        const idPuntoInspeccion = this.form.controls['IdPuntoInspeccion'].value;
        this.onChangePuntoInspeccion.emit(idPuntoInspeccion);

        this.form.patchValue({
            IdUbicacion: null,
            IdInstalacionAutorizada: null,
        });

        this.form.controls['IdInstalacionAutorizada'].enable();
        this.form.controls['IdUbicacion'].enable();
        this.form.controls['IdIntervaloHoras'].reset();
        this.campoInstalacion = true;
    }

    onSelectUbicacion() {
        if (this.form.controls['IdUbicacion'].value === null) {
            this.form.controls['IdInstalacionAutorizada'].enable();
            this.addValidator('IdInstalacionAutorizada', Validators.required);
            this.campoInstalacion = true;
        } else {
            this.form.controls['IdInstalacionAutorizada'].reset();
            this.form.controls['IdInstalacionAutorizada'].disable();
            this.removeValidators('IdInstalacionAutorizada');
            this.campoInstalacion = false;
        }
    }

    onSelectInstalacionAutorizada() {
        if (this.form.controls['IdInstalacionAutorizada'].value === null) {
            this.form.controls['IdUbicacion'].enable();
            this.addValidator('IdUbicacion', Validators.required);
            this.campoUbicacion = true;
        } else {
            this.form.controls['IdUbicacion'].reset();
            this.form.controls['IdUbicacion'].disable();
            this.removeValidators('IdUbicacion');
            this.campoUbicacion = false;
        }
        this.form.controls['IdIntervaloHoras'].reset();
    }

    get isDisabled(): boolean {
        return this.validacionCollection?.length > 0;
    }
}
